import { type RouteRecordRaw } from 'vue-router'
import ReportDesignPage from '../../pages/ReportDesignPage.vue'
import {ROUTES} from '@myorg/type-lib'


export const ReportDesignRoute: RouteRecordRaw = {
    path: ROUTES.REPORT.PATH,
    name: ROUTES.REPORT.NAME,
    component: ReportDesignPage,
}